import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loading } from '@leegality/leegality-react-component-library';
import { usePrincipalGroupId, useProfileSelectionActions } from '@app/profile-selection-store';
import { useLocale } from '@app/store';
import { loadLocale, isLocaleLoaded } from '@constants/locales';
import { useFetchClientMetaDataQuery } from '@pages/api/fetch-client-meta-data';
import useMobileView from '@hooks/use-mobile-view';
import DesktopLayout from './layouts/desktop-layout';
import MobileLayout from './layouts/mobile-layout';

const Dashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const principalGroupIdFromUrl = searchParams.get('principalGroupId');
  const principalGroupId = usePrincipalGroupId();
  const { setPrincipalGroupId } = useProfileSelectionActions();
  const { data, isLoading } = useFetchClientMetaDataQuery();
  const isMobile = useMobileView();
  const locale = useLocale();
  const [readyLocale, setReadyLocale] = useState(() => (isLocaleLoaded(locale) ? locale : null));

  useEffect(() => {
    if (isLocaleLoaded(locale)) {
      setReadyLocale(locale);
      return;
    }
    let cancelled = false;
    loadLocale(locale).then(() => {
      if (!cancelled) setReadyLocale(locale);
    });
    // eslint-disable-next-line consistent-return
    return () => { cancelled = true; };
  }, [locale]);

  useEffect(() => {
    setSearchParams((prevParams) => {
      const newParams = new URLSearchParams(prevParams);
      if (principalGroupIdFromUrl) {
        newParams.set('principalGroupId', principalGroupIdFromUrl);
        setPrincipalGroupId(principalGroupIdFromUrl);
      } else if (principalGroupId) {
        newParams.set('principalGroupId', principalGroupId);
        setPrincipalGroupId(principalGroupId);
      } else {
        newParams.delete('principalGroupId');
      }
      return newParams;
    });
  }, [principalGroupIdFromUrl, principalGroupId, setSearchParams]);

  if (isLoading || !data?.data?.properties?.logoPath || readyLocale !== locale) {
    return <Loading />;
  }

  const logoPath = data?.data?.properties?.logoPath;

  return isMobile
    ? <MobileLayout key={readyLocale} logoPath={logoPath} />
    : <DesktopLayout key={readyLocale} logoPath={logoPath} />;
};

export default Dashboard;
